import { ResponseMode } from '@/typings/params'
import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router'
import store from '../../store'

export async function syncIng (to: RouteLocationNormalized, next: NavigationGuardNext) {
  const { success }: ResponseMode = await doAuth(to, next)
  // if (!success) throw Error('授权失败')
  initBusinessData()

}

/**
 * 初始化业务数据
 */
export async function initBusinessData () {
  // 字典值
  const { isLoadedDict } = store.getters || {}
  if (!isLoadedDict) {
    await store.dispatch('initDict')
  }
}

/**
 * 认证
 * @param to
 */
export async function doAuth (to: RouteLocationNormalized, next: NavigationGuardNext): Promise<any> {
  const result: ResponseMode = { success: store.getters.isLogin }

  try {
    if (store.getters.isLogin) return result
    const { VITE_ENV, VITE_USERNAME, VITE_PASSWORD } = import.meta.env
    if (!result.success) return next('/login')
    return result
  } catch (error) {
    return result
  }
}
